import { useState } from 'react'
import Splash from './Splash'
import Welcome from './Welcome'
import Healthcare from './Healthcare'
import Environment from './Environment'
import Exercise from './Exercise'
import Intro from './Intro'
import SiteMap from './SiteMap'
import ESCFooter from './ESCFooter'
import ESCHeader from './ESCHeader'
import Soon from './Soon'

const Container = () => {
  const [screen, setScreen] = useState('welcome')

  const onScreenUpdate = (newScreen) => {
    setScreen(newScreen)
  }

  return (
    <div className="container">
      {/* Preload bloop audio */}
      <audio id="bloop" src="audio/fx/bloop.mp3" preload="auto" />

      <ESCHeader />

      {/* conditionally load a screen */}
      {screen === 'splash' ? (
        <Splash onScreenUpdate={onScreenUpdate} />
      ) : screen === 'welcome' ? (
        <Welcome onScreenUpdate={onScreenUpdate} />
      ) : screen === 'healthcare' ? (
        <Healthcare onScreenUpdate={onScreenUpdate} />
      ) : screen === 'sitemap' ? (
        <SiteMap onScreenUpdate={onScreenUpdate} />
      ) : screen === 'environment' ? (
        <Environment onScreenUpdate={onScreenUpdate} />
      ) : screen === 'exercise' ? (
        <Exercise onScreenUpdate={onScreenUpdate} />
      ) : screen === 'intro' ? (
        <Intro onScreenUpdate={onScreenUpdate} />
      ) : screen === 'soon' ? (
        <Soon onScreenUpdate={onScreenUpdate} />
      ) : (
        <div>placeholder</div>
      )}
      <ESCFooter />
    </div>
  )
}

export default Container
